// app/modules/chatbot/ChatbotWidget.jsx

import './index.css'
import { useEffect, useState } from 'react'
import Chat from './components/Chat'
import { fetchContext } from './api/client'

export default function ChatbotWidget({ onActivity }) {
    const [context, setContext] = useState(null)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)

    useEffect(() => {
        const raw = window.localStorage.getItem('Authorization')

        if (!raw) {
            setError('You must be logged in to use the chatbot.')
            setLoading(false)
            return
        }

        // Strip "Bearer " if it's already there, so we don't double it up
        const token = raw.startsWith('Bearer ') ? raw.slice(7) : raw

        const loadContext = async () => {
            setLoading(true)
            setError(null)
            try {
                const data = await fetchContext(token)
                setContext({
                    sessionId: data.session_id,
                    greeting: data.greeting,
                    allowedBus: data.allowed_bus,
                    user: data.user,
                    token: token,
                })
            } catch (e) {
                setError('Could not start chat session. Please try again.')
            } finally {
                setLoading(false)
            }
        }

        loadContext()
    }, [])

    return (
        <div className="chatbot-widget">
            {loading && <div className="chatbot-status">Loading chat...</div>}
            {!loading && error && <div className="chatbot-status chatbot-error">{error}</div>}
            {!loading && !error && <Chat context={context} onActivity={onActivity} />}
        </div>
    )
}